<template>
  <form
    class="form form--login"
    method="post"
    @submit.prevent="submit"
    ref="form"
  >
    <div class="form-errors" v-if="formError">
      {{ formError }}
    </div>

    <div :class="formItemClasses('user')">
      <input
        class="form-element form--login__user"
        type="text"
        name="user"
        :placeholder="t('login.user')"
        v-model="user"
        autofocus
      />
    </div>
    <div :class="formItemClasses('password')">
      <input
        class="form-element form--login__pwd"
        type="password"
        name="pwd"
        :placeholder="t('login.password')"
        v-model="pwd"
      />
    </div>
    <div >
      <div class="form-errors-reset" v-if="formError">
        Haben Sie Ihr
        <router-link class="pw-reset" to="/passwort-zuruecksetzen">
          Passwort vergessen?
        </router-link>
      </div>
    </div>
    <div class="form-actions">
      <LinkButton
        icon-right="Arrow"
        form="login"
        :text="t('login.submit')"
        :disable-on-submit="true"
      />
    </div>

    <router-link class="form--login__pw-reset" to="/passwort-zuruecksetzen">
      Passwort vergessen?
    </router-link>
  </form>
</template>

<script>
  import LinkButton from '@/components/LinkButton.vue'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useAuthStore } from '@/stores/useAuthStore'
  import { useRouter } from 'vue-router'
  import { computed } from 'vue'

  export default {
    name: 'form-login',
    setup() {
      const router = useRouter()
      const authStore = useAuthStore()
      const { t } = useStrings()
      return {
        t,
        router,
        authStore,
      }
    },
    data: () => {
      return {
        user: '',
        pwd: '',
        error: '',
        focusedFormItem: '',
      }
    },
    components: {
      LinkButton,
    },
    computed: {
      formError: function () {
        return this.authStore.errorMessage
      },
    },
    methods: {
      formItemClasses: function (id) {
        let classes = ['form-item']
        if (this.focusedFormItem && this.focusedFormItem === id) {
          classes.push('form-item--focused')
        }
        return classes.join(' ')
      },
      async submit() {
        if (this.user.length < 5 || this.pwd.length < 5) {
          this.authStore.errorMessage = this.t('authentication.provideUserNameAndPassword')
        } else {
          this.error = null
        }

        this.authStore.login({
          user: this.user,
          pwd: this.pwd,
          router: this.router,
        })
      },
    },
  }
</script>

<style lang="scss">
  .form--login {
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
    transition: $transition-base;

    @media (min-height: 360px) {
      margin-top: 8vh;
    }

    @media (min-height: 400px) {
      margin-top: 20vh;
    }

    &__pw-reset {
      margin-top: $spacer10;
      display: inline-block;
      cursor: pointer;

      @media (min-height: 400px) {
        margin-top: $spacer20;
      }
    }

    .form-errors {
      padding: 10px 15px 10px 15px;
      border-radius: 6px;
      background-color: color.adjust($error-color, $lightness: 50%);
      border: 2px solid $error-color;
      margin-bottom: 20px;
    }
  }

  .pw-reset {
    cursor: pointer;
    color: $community;

    @include hover-focus-active {
      color: color.adjust($community, $lightness: -5%);
    }
  }
</style>
